import styled from '@emotion/styled';
import Tags from '@base/Tags/Tags';
import { Spacings } from '@styles/index';

const StyledTag = styled(Tags)`
  width: fit-content;
  transition: all 300ms ease;
  margin: ${Spacings.SPACING_0B} ${Spacings.SPACING_2B} ${Spacings.SPACING_2B}
    ${Spacings.SPACING_0B};
  border: ${({ $hasBorder }) => {
    return $hasBorder
      ? `${Spacings.SPACING_1} solid var(--color-divider)}`
      : Spacings.SPACING_0B;
  }};
`;

const Container = styled.div``;

const BatchGroupTags = ({
  languages = [],
  classType,
  hasBorder,
  tagsBGColor
}) => {
  return (
    <Container>
      {languages.map((language) => {
        return (
          <StyledTag
            $hasBorder={hasBorder}
            bgColor={tagsBGColor}
            type="hollow"
            key={language.label}
          >
            {language.label}
          </StyledTag>
        );
      })}
      {classType?.text && (
        <StyledTag $hasBorder={hasBorder} bgColor={tagsBGColor} type="hollow">
          {classType.text}
        </StyledTag>
      )}
    </Container>
  );
};
export default BatchGroupTags;
